<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-EPI">ALTHOUGH THE FOLLOWING ACCOUNT IS TRUE, THE NAMES OF CERTAIN PERSONS AND PLACES HAVE BEEN CHANGED IN THE INTEREST OF PRESERVING THEIR ANONYMITY AND PROTECTING MY OWN LIFE.</p>
<p class="ORIM-EPIC">S.W.F.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fussell_Muscle_4P_MD4.vue?d3a97208